import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { APISERVICE } from '../../../services/api.service'
import FormAdministration from './FormAdministration'

export default function Administracion() {
    const [value, setValue] = useState(null)
    const [loading, setLoading] = useState(false)

    const getConfig = async () => {
        const url = 'configuracion/get?claves[]=cantidad_notificaciones&claves[]=duracion_notificaciones'
        const data = await APISERVICE.get(url, '')
        if (data.cantidad_notificaciones && data.duracion_notificaciones) {
            setValue(data)
        }
    }
    const setConfig = async (body) => {
        try {
            setLoading(true)
            const url = 'configuracion/batch-update'
            const data = [
                {
                    id: value.cantidad_notificaciones.id,
                    valor: body.cantidad_notificaciones.toString(),
                },
                {
                    id: value.duracion_notificaciones.id,
                    valor: body.duracion_notificaciones.toString(),
                },
            ]
            const { success, message } = await APISERVICE.post(url, '', {data})
            if (success) {
                getConfig()
                toast.success(message)
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getConfig()
    }, [])
    return (
        <section className='contenedor pt-3'>
            <div className='fs-3'>Configuración de sistema</div>
            <FormAdministration value={value} setConfig={setConfig} loading={loading} />
        </section>
    )
}
